module.exports = __webpack_public_path__ + "img/pic_location_Ind_Jakarta.e007c5b8.png";